import moment from 'moment'

const momentRange = moment as any

export const getDateInterval = ({ periodValue, periodUnit, sumPeriod }) => {
  // Get the dates of interest
  const startDate = moment()
    .local()
    .subtract(periodValue, periodUnit)
    .startOf(sumPeriod)
  const endDate = moment()
    .local()
    .startOf(sumPeriod)
  const dateRange = momentRange.range(startDate, endDate)
  return Array.from(dateRange.by(sumPeriod)).map((date: any) => date.format())
}



// WEBPACK FOOTER //
// src/features/CallAnalytics/utils/getDateInterval.ts